import React from "react";
import { Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { SbTable } from "uiCore";
import { BackLinkStyled } from "../../RoleDetailV2.styles";
import { DetailHeadingRowStyled, PlanTableWrapperStyled } from "../ViewPlanningV2.styles";
import { tableEmptyLocale } from "../ViewPlanningV2.utils";

const { Title } = Typography;

// The selected plan's detail rows — redeployment roles or workforce jobs.
// Both tabs share this back-link + heading + clickable-table shell; only the
// columns, row identity, and empty message differ. Rendered as a fragment so
// the tab pane's flex column (TabsBodyStyled) can hand the remaining
// height to the table wrapper, which owns the scroll.
const PlanDrillDownList = ({ planName, columns, rows, rowKey, emptyMessage, onSelect, onBack }) => (
  <>
    <BackLinkStyled onClick={onBack}>
      <ArrowLeftOutlined /> Back to Plans
    </BackLinkStyled>
    <DetailHeadingRowStyled>
      <Title level={5}>{planName}</Title>
    </DetailHeadingRowStyled>
    <PlanTableWrapperStyled>
      <SbTable
        columns={columns}
        dataSource={rows || []}
        rowKey={rowKey}
        sticky
        onRow={(record) => ({ onClick: () => onSelect(record) })}
        locale={tableEmptyLocale(rows, emptyMessage)}
      />
    </PlanTableWrapperStyled>
  </>
);

export default PlanDrillDownList;
